import { render } from "./CancelBooking.vue?vue&type=template&id=2fee4690&scoped=true"
import script from "./CancelBooking.vue?vue&type=script&lang=js"
export * from "./CancelBooking.vue?vue&type=script&lang=js"

import "./CancelBooking.vue?vue&type=style&index=0&id=2fee4690&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fee4690"]])

export default __exports__